/* Sportconic cart-drawer: "+ Toevoegen" bij aanbevolen accessoires.
   Voegt het product toe via /cart/add.js en laat Dawn's eigen cart-drawer.renderContents()
   de hele drawer verversen (items, gratis-verzending-balk, aanbevelingen, winkelwagen-icoon)
   en opnieuw openen — zonder paginavernieuwing. */
(function () {
  if (window.__spCartRecInit) return;
  window.__spCartRecInit = true;

  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Houd de is-empty-class op <cart-drawer> in sync. renderContents doet dit alleen
  // voor .drawer__inner, niet voor het buitenste element → anders blijft bij de
  // eerste toevoeging de lege-staat-layout (geen header, gecentreerd leeg vlak) hangen.
  function spSyncEmpty(drawer, data) {
    if (!drawer) return;
    if (data && typeof data.item_count === 'number') {
      drawer.classList.toggle('is-empty', data.item_count === 0);
    } else {
      drawer.classList.remove('is-empty');
    }
  }

  /* Cart-respons toepassen: op de winkelwagenpagina stil (drawer bijwerken zonder
     openen + pagina verversen, via sportconic-cart-page.js); elders via Dawn's
     renderContents, die de drawer ook opent. */
  function spApply(data) {
    if (window.spCartPageApply) { window.spCartPageApply(data); return; }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && data) {
      spSyncEmpty(drawer, data);
      drawer.renderContents(data);
    } else {
      window.location.reload();
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sp-cart-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;

    var vid = btn.getAttribute('data-sp-cart-add');
    var drawer = document.querySelector('cart-drawer');
    if (!vid) return;
    btn.classList.add('is-loading');

    var sectionIds = drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];

    fetch(routeRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: vid, quantity: 1 }],
        sections: sectionIds,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) { btn.classList.remove('is-loading'); return; } // foutmelding van Shopify
        spApply(data);
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  });

  /* ── Garantie-uitbreiding: in-/uitklappen ── */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-sp-war-toggle]');
    if (!toggle) return;
    var box = toggle.closest('[data-sp-war]');
    if (!box) return;
    var open = box.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ── Garantie-keuze: zet beide garantie-varianten in één update en ververs de drawer ──
     Capture-fase + stopPropagation, zodat Dawn's aantal-validatie dit radio-event
     niet oppakt (anders verschijnt onterecht "alleen toevoegen in stappen van"). */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('input[name="sp-war"]')) return;
    e.stopPropagation();
    var box = input.closest('[data-sp-war]');
    if (!box || box.classList.contains('is-busy')) return;

    var w1 = box.getAttribute('data-w1');
    var w2 = box.getAttribute('data-w2');
    var val = input.value;
    /* Garantie geldt per loopband: aantal garanties = aantal loopbanden in de wagen. */
    var treadQty = parseInt(box.getAttribute('data-tread-qty'), 10) || 1;
    var sel = box.getAttribute('data-war-sel') || '0';

    box.classList.add('is-busy');
    var drawer = document.querySelector('cart-drawer');
    var sectionIds = drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];
    var jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

    var finish = function (data) { spApply(data); };
    var fail = function () { box.classList.remove('is-busy'); };

    /* LET OP: cart/update.js kan alleen BESTAANDE regels wijzigen (aantal/verwijderen);
       een nieuwe garantie toevoegen moet via cart/add.js. */
    if (val === '0') {
      var offUpdates = {};
      offUpdates[w1] = 0;
      offUpdates[w2] = 0;
      fetch(routeRoot + 'cart/update.js', {
        method: 'POST',
        headers: jsonHeaders,
        body: JSON.stringify({ updates: offUpdates, sections: sectionIds, sections_url: window.location.pathname }),
      }).then(function (r) { return r.json(); }).then(finish).catch(fail);
    } else {
      var chosen = val === '1' ? w1 : w2;
      var other = val === '1' ? w2 : w1;
      var addChosen = function () {
        return fetch(routeRoot + 'cart/add.js', {
          method: 'POST',
          headers: jsonHeaders,
          body: JSON.stringify({ items: [{ id: parseInt(chosen, 10), quantity: treadQty }], sections: sectionIds, sections_url: window.location.pathname }),
        }).then(function (r) { return r.json(); });
      };
      if (sel === val) {
        /* Zelfde optie opnieuw → alleen het aantal bijtrekken (regel bestaat al). */
        var qtyUpdates = {};
        qtyUpdates[chosen] = treadQty;
        fetch(routeRoot + 'cart/update.js', {
          method: 'POST',
          headers: jsonHeaders,
          body: JSON.stringify({ updates: qtyUpdates, sections: sectionIds, sections_url: window.location.pathname }),
        }).then(function (r) { return r.json(); }).then(finish).catch(fail);
      } else if (sel !== '0') {
        /* Wissel: eerst de andere garantie eruit (bestaande regel), dan de gekozen erin. */
        var removeOther = {};
        removeOther[other] = 0;
        fetch(routeRoot + 'cart/update.js', {
          method: 'POST',
          headers: jsonHeaders,
          body: JSON.stringify({ updates: removeOther }),
        }).then(function () { return addChosen(); }).then(finish).catch(fail);
      } else {
        /* Nog geen garantie → gewoon toevoegen. */
        addChosen().then(finish).catch(fail);
      }
    }
  }, true);

  /* ── Garantie-aantal synchroon houden met het aantal loopbanden ──
     Wijzigt de klant het loopband-aantal ná het kiezen van een garantie, dan wordt
     het garantie-aantal automatisch bijgetrokken. De drawer rendert bij elke
     cart-wijziging opnieuw (Liquid zet data-tread-qty/data-war-sel/data-war-qty);
     deze observer kijkt na elke render of ze nog kloppen. Zodra ze gelijk zijn,
     vuurt er niets meer — geen lus. ── */
  var spWarSyncBusy = false;
  var spWarObserver = new MutationObserver(function () {
    if (spWarSyncBusy) return;
    var box = document.querySelector('[data-sp-war]');
    if (!box || box.classList.contains('is-busy')) return;
    var sel = box.getAttribute('data-war-sel');
    if (sel !== '1' && sel !== '2') return; // geen garantie gekozen → niets te syncen
    var treadQty = parseInt(box.getAttribute('data-tread-qty'), 10) || 0;
    var warQty = parseInt(box.getAttribute('data-war-qty'), 10) || 0;
    if (treadQty < 1 || warQty === treadQty) return; // (0 loopbanden ruimt de wees-cleanup al op)
    spWarSyncBusy = true;
    var vid = sel === '1' ? box.getAttribute('data-w1') : box.getAttribute('data-w2');
    var updates = {};
    updates[vid] = treadQty;
    var drawer = document.querySelector('cart-drawer');
    var sectionIds = drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];
    fetch(routeRoot + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: sectionIds, sections_url: window.location.pathname }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        spApply(data);
        spWarSyncBusy = false;
      })
      .catch(function () { spWarSyncBusy = false; });
  });
  var spWarDrawer = document.querySelector('cart-drawer');
  if (spWarDrawer) spWarObserver.observe(spWarDrawer, { childList: true, subtree: true });

  /* ── "−" bij aantal 1 verwijdert de regel (anders blokkeert de min-1-regel met
     "minimale hoeveelheid is 1"). Capture-fase, zodat Dawn's eigen handler niet eerst draait. ── */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('.cart-drawer .cart-item .quantity__button[name="minus"]');
    if (!minus) return;
    var input = minus.parentElement && minus.parentElement.querySelector('.quantity__input');
    var val = input ? parseInt(input.value, 10) : 0;
    if (val > 1) return; // gewoon verlagen
    e.preventDefault();
    e.stopPropagation();
    var item = minus.closest('.cart-item');
    if (!item) return;

    // Loopband verwijderen → cadeaus + garantie meenemen (anders blijven die orphan achter)
    if (item.hasAttribute('data-sp-tread')) {
      var vids = (item.getAttribute('data-sp-bundle') || '').split(',').filter(Boolean);
      var self = item.getAttribute('data-sp-self');
      if (self) vids.push(self);
      var updates = {};
      vids.forEach(function (v) { updates[v] = 0; });
      var drawer = document.querySelector('cart-drawer');
      var sectionIds = drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map(function (s) { return s.id; })
        : ['cart-drawer', 'cart-icon-bubble'];
      fetch(routeRoot + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates, sections: sectionIds, sections_url: window.location.pathname }),
      })
        .then(function (r) { return r.json(); })
        .then(function (data) { spApply(data); })
        .catch(function () {});
      return;
    }

    // Overige producten: gewone enkele verwijdering
    var removeBtn = item.querySelector('cart-remove-button');
    if (removeBtn) removeBtn.click();
  }, true);

  /* ── Wees-opruimer: verwijdert cadeau/garantie-items die zonder loopband achterblijven.
     Vangt ALLE verwijderpaden af (aantal op 0 typen, Dawn's eigen remove, enz.) via een
     MutationObserver op de cart-drawer. Liquid levert de te verwijderen variant-ids in
     [data-sp-orphans] zodra er geen loopband meer in de wagen zit. ── */
  var spCleaning = false;
  function spCleanupOrphans() {
    if (spCleaning) return;
    var el = document.querySelector('[data-sp-orphans]');
    if (!el) return;
    var vids = (el.getAttribute('data-sp-orphans') || '').split(',').filter(Boolean);
    if (!vids.length) return;
    spCleaning = true;
    var updates = {};
    vids.forEach(function (v) { updates[v] = 0; });
    var drawer = document.querySelector('cart-drawer');
    var sectionIds = drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];
    fetch(routeRoot + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: sectionIds, sections_url: window.location.pathname }),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        spCleaning = false;
        spApply(data);
      })
      .catch(function () { spCleaning = false; });
  }
  var spCd = document.querySelector('cart-drawer');
  if (spCd && window.MutationObserver) {
    new MutationObserver(function () { spCleanupOrphans(); }).observe(spCd, { childList: true, subtree: true });
  }
  spCleanupOrphans();
})();
